import * as React from "react"

export function MakerWorld(props: { link: string }) {
  return (
    <a target="_blank" href={props.link}>
      <svg
        width="auto"
        height={24}
        viewBox="0 0 91 91"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_2116_11816)">
          <path
            d="M66.2248 0L45.3626 8.19343L24.5003 0L0 9.62409V81.3796L24.5003 91.0037L45.3626 82.8102L66.2248 91.0037L90.7251 81.3796V9.62409L66.2248 0ZM66.2248 3.91241L87.0871 12.1058V41.7153L66.2248 33.5256V3.91241ZM66.2248 37.4416L86.7554 45.5037L66.2248 53.5657L45.6943 45.5037L66.2248 37.4416ZM24.5003 3.91241L45.3626 12.1058V41.7153L24.5003 33.5256V3.91241ZM24.5003 37.4416L45.0272 45.5037L24.4967 53.5657L3.96977 45.5037L24.5003 37.4416ZM3.63805 78.8942V49.2847L24.5003 57.4745V87.0876L3.63805 78.8942ZM45.3626 78.8942V49.2847L66.2248 57.4745V87.0876L45.3626 78.8942Z"
            fill="currentColor"
          ></path>
        </g>
      </svg>
    </a>
  )
}
